import React from 'react'
import { Button } from 'react-bootstrap'
import {ReactComponent as WebsiteHeroImage} from '../../../Assets/WebsiteHeroImage.svg'
import {ReactComponent as WebsiteHeroImageLight} from '../../../Assets/WebsiteHeroImageLight.svg'

const Hero = (props: {darkMode: boolean}) => {
    return (
        <div className='container web-hero-section' >
        <div className='text-center '>
            <h1 className='web-hero-heading'><b>Welcome to Notion Diary</b></h1>
            <h4 className='web-hero-subheading'>Showcase your thoughts with the world </h4>
            <Button className='cta animated-cta  cta-large mt-5' href='/auth'>Get Started</Button>
            <div>
                {props.darkMode ? <WebsiteHeroImageLight/> : <WebsiteHeroImage/>}
            </div>
        </div>
        </div>
    )
}

export default React.memo(Hero)
